import { ENV } from "../utils";

export class Training {
  baseApi = ENV.BASE_API;

  async getCapacitaciones(accessToken, params = {}) {
    const query = new URLSearchParams();
    if (params.active !== undefined) query.set("active", params.active);
    if (params.site) query.set("site", params.site);
    if (params.year) query.set("year", params.year);
    const url = `${this.baseApi}/capacitaciones?${query.toString()}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getCapacitacion(accessToken, id) {
    const response = await fetch(`${this.baseApi}/capacitacion/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createCapacitacion(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-capacitacion`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateCapacitacion(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-capacitacion/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteCapacitacion(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-capacitacion/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async uploadFile(accessToken, id, formData) {
    const response = await fetch(`${this.baseApi}/capacitacion/${id}/upload-file`, {
      method: "POST",
      body: formData,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getFile(accessToken, fileName) {
    const response = await fetch(`${this.baseApi}/capacitacion-file/${fileName}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) return null;
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  }

  async deleteFile(accessToken, id, fileName) {
    const response = await fetch(`${this.baseApi}/capacitacion/${id}/delete-file`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({ fileName }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
